import { Dismiss } from '@wix/wix-ui-icons-common';
import classNames from 'classnames';
import React, { FC } from 'react';

import { dismissCopilot } from '../../../messageChannel/postNewMessages';
import { renderModel } from '../../../util/renderModel';
import css from './styles.scss';

const isCopilot = renderModel.isCopilot();

export const CancelButton: FC<{}> = (props) => {
  return (
    <Dismiss
      onClick={dismissCopilot}
      className={classNames(css.cancelButton, { [css.copilot]: isCopilot })}
    />
  );
};
